import { render, staticRenderFns } from "./cards-board-columns.vue?vue&type=template&id=c3f8910a&scoped=true"
import script from "./cards-board-columns.vue?vue&type=script&lang=js"
export * from "./cards-board-columns.vue?vue&type=script&lang=js"
import style0 from "./cards-board-columns.vue?vue&type=style&index=0&id=c3f8910a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f8910a",
  null
  
)

export default component.exports